module.exports = __webpack_public_path__ + "static/media/Arial Rounded Bold.8aa0ab49.ttf";